import React from "react";
import ProjectLayout from "../components/ProjectLayout";
import heroImage from "../../../assets/Images/project/project-banner.png";

const IrrigationSector = () => {
  return (
    <ProjectLayout
      heroImage={heroImage}
      title="Surveying - Irrigation Sector"
      subtitle="Canal/River front/Dame/ catchment area - More than 110 KM and 5000 Hectare."
      sector="SURVEYING"
      subCategory="IRRIGATION SECTOR"
    />
  );
};

export default IrrigationSector;
